import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { SafeUrlPipe } from 'src/app/shared/pipes/safe-url.pipe';
import { ITrip } from 'src/app/core/types/interfaces/popular-trip.interface';

import { TripsService } from 'src/app/core/services/trips.service';
import { LocationListModule } from 'src/app/shared/location-list/location-list.module';

import { PopularTripSheetComponent } from 'src/app/shared/sheets/popular-trip-sheet/popular-trip-sheet.component';

@Component({
  selector: 'app-itinerary-card-mobile',
  templateUrl: './itinerary-card-mobile.component.html',
  styleUrls: ['itinerary-card-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    SafeUrlPipe,
    TranslateModule,
    LocationListModule,
    NgxSkeletonLoaderModule,
  ],
})
export class ItineraryCardMobileComponent {
  @Input() isFetching: boolean = false;
  @Input() itinerary: any | null = null;
  @Output() makeItMyPlan: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    protected bottomSheet: MatBottomSheet,
    private tripsService: TripsService,
  ) {}

  get tripRange(): string {
    let range = '12';

    if (this.itinerary && this.itinerary.duration_range) {
      const separator = '-';
      range = this.itinerary.duration_range.replace(
        /(\s*to\s*)|(\s*\-\s*)/gi,
        separator,
      );
      const rangeArr = range.split(separator);

      if (rangeArr.length === 2 && rangeArr[0] === rangeArr[1]) {
        return rangeArr[0];
      }
    }

    return range;
  }

  openTripOverview(): void {
    const { tripData } = this.itinerary;
    const openDialogWithAdvanceInfo = (trip: ITrip) => {
      this.bottomSheet
        .open(PopularTripSheetComponent, {
          hasBackdrop: false,
          closeOnNavigation: true,
          panelClass: 'custom-bottom-sheet',
          data: {
            trip: trip,
          },
        })
        .afterDismissed()
        .subscribe((res) => {
          if (res) {
            this.makeItMyPlan.emit(res);
          }
        });
    };

    if (!tripData) {
      this.tripsService
        .getTripByUrlName(this.itinerary.url)
        .subscribe((tripData) => {
          if (tripData) {
            const trip = { ...this.itinerary, tripData: tripData };
            openDialogWithAdvanceInfo(trip);
          }
        });
    } else {
      openDialogWithAdvanceInfo(this.itinerary);
    }
  }
}
